/**
 * Legacy authenticated model discovery. Shader generation uses the linked
 * desktop account through ShaderCodeModelHost; this module cannot generate.
 */

import { ShaderGenerationError } from '../types'
import { getJson } from './openai-compatible'
import type { ShaderModelOption } from './openai-compatible'

export const XAI_API_URL = 'https://api.x.ai/v1'

/** Image, video and voice models share the listing; none of them writes code. */
const NON_TEXT_MODEL = /imagine|image|video|voice|embed|tts|audio/i

function unreachable(): ShaderGenerationError {
  return new ShaderGenerationError('Could not reach xAI. Check your connection and try again.', 'NETWORK')
}

interface XaiModelsResponse {
  data?: Array<{ id?: string }>
}

/** The text models this key can use. */
export async function listGrokModels(key: string, signal?: AbortSignal): Promise<ShaderModelOption[]> {
  const body = await getJson<XaiModelsResponse>(
    { url: `${XAI_API_URL}/models`, label: 'Grok', headers: { Authorization: `Bearer ${key}` }, secret: key, onNetworkError: unreachable },
    signal,
  )
  return (body.data ?? [])
    .map((model) => model.id)
    .filter((id): id is string => typeof id === 'string' && !NON_TEXT_MODEL.test(id))
    .map((id) => ({ id, label: id }))
}
